import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, map, retry } from 'rxjs';
import { Clinic } from '../models/clinic.model';

const BASE_URL_SECOND = environment.base_url_second;

export interface PrescriptionTemplate {
    ID?: string,
    type: string,
    name: string,
    prescription: any,
    clientID: string,
    createdAt: number,
    updatedAt: number,
    createdBy: string
    description?: string,
    image?: string,
    metadata?: Record<string, any>
}

@Injectable({
    providedIn: 'root'
})
export class PrescriptionTemplatesService {

    constructor(
        private http: HttpClient
    ) { }

    getPrescriptionTemplatesByClientID(clientID: string): Observable<PrescriptionTemplate[]> {

        const url = `${BASE_URL_SECOND}/prescriptionTemplates/${clientID}`;

        return this.http.get<PrescriptionTemplate[]>(url)
    }

    getPrescriptionTemplateByID(prescriptionTemplateID: string): Observable<PrescriptionTemplate> {

        const url = `${BASE_URL_SECOND}/prescriptionTemplate/${prescriptionTemplateID}`;

        return this.http.get<PrescriptionTemplate>(url)
    }

    createPrescriptionTemplate(prescriptionTemplateData: PrescriptionTemplate) {

        const url = `${BASE_URL_SECOND}/prescriptionTemplate`;

        return this.http.post(url, prescriptionTemplateData)
    }

    updatePrescriptionTemplate(prescriptionTemplateId: string, prescriptionTemplateData: PrescriptionTemplate) {

        const url = `${BASE_URL_SECOND}/prescriptionTemplate/${prescriptionTemplateId}`;

        const body = prescriptionTemplateData

        return this.http.put(url, body).pipe(
            map((resp) => resp)
        )
    }

}
